import CandidatesDataComponent from '../Components/Support/CandidatesDataComponent';

function CandidatesDataPage() {
  return <CandidatesDataComponent />;
}

export default CandidatesDataPage;
